import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rerunData: null,
}

const flexicoRerunSlice = createSlice({
    name: 'flexicoRerun',
    initialState,
    reducers: {
        setRerunData(state, action) {
            state.rerunData = action.payload
        },
        clearRerunData(state) {
            state.rerunData = null
        }
    }
})

export const { setRerunData, clearRerunData } = flexicoRerunSlice.actions

export default flexicoRerunSlice.reducer
